module.exports = __webpack_public_path__ + "static/media/hu.93b63080.svg";